<template>
  <navbar v-model="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" @click="minimizeSidebar">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar">

        </navbar-toggle-button>
      </div>
      <a class="navbar-brand" href="#pablo">{{this.$route.name}}</a>
    </div>

    <template slot="navbar-menu">
      <!--
      <form>
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <div class="input-group-append">
            <div class="input-group-text">
              <i class="nc-icon nc-zoom-split"></i>
            </div>
          </div>
        </div>
      </form>
      -->
      <ul class="navbar-nav">
        
        <li v-if="PinnedUserAndNotLocalHost && this.hasValhallaScale" class="nav-item" :key="componentKey">
          <a v-on:click="openInitialReport" class="nav-link btn-rotate" title="View Initial Report">
            <i class="nc-icon nc-paper"></i>
          </a>
        </li>

        <li v-if="PinnedUserAndNotLocalHost && this.hasValhallaScale" class="nav-item" :key="componentKeyTwo">
          <a v-on:click="openFollowUpReport" class="nav-link btn-rotate" title="View Follow-Up Report">
            <i class="nc-icon nc-single-copy-04"></i>
          </a>
        </li>
        
        <li v-if="PinnedUserAndNotLocalHost" class="nav-item">
          <a v-on:click="openUserMessageModal" class="nav-link btn-rotate" title="Send a Message">
            <i class="nc-icon nc-email-85"></i>
          </a>
        </li>
        <li v-if="PinnedUserAndNotLocalHost" class="nav-item">
          <a v-on:click="openUserDocumentModal" class="nav-link btn-rotate" title="Send a document">
            <i class="fa fa-file-o" aria-hidden="true"></i>
          </a>
        </li>

        <drop-down icon="nc-icon nc-share-66" tag="li"
          position="right"
          direction="none"
          class="nav-item btn-rotate dropdown"
          v-if="PinnedUserAndNotLocalHost && this.practiceHasSurveys" 
          :key="componentKeyFour">
          <a slot="title"
             slot-scope="{isOpen}"
             class="nav-link dropdown-toggle"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="nc-icon nc-share-66" title="Send a Survey"></i>
          </a>
          <h6 class="dropdown-header text-center">Send a Survey</h6>
          <div v-for="survey in surveys" v-bind:key="survey.id">
            <div class="dropdown-item" @click="sendSurvey(survey)">
              {{survey.title}}
            </div>
          </div>
        </drop-down>
        <!-- <router-link to="/ProgressTracker" class="nav-item coust-mt-2 mr-3" v-if="showAIChatBotIcon">
          <i class="nc-icon nc-chat-33" 
            data-bs-toggle="tooltip" 
            data-bs-placement="right" 
            title="Progress Tracker" 
            style="font-size: 20px; cursor: pointer;"></i>
        </router-link> -->
        <drop-down icon="nc-icon nc-layout-11" tag="li"
                   position="right"
                   direction="none"
                   class="nav-item btn-rotate dropdown"
                   v-if="this.isOnDraggableDashboard"
                   :closeOnClick="false">
          <a slot="title"
             slot-scope="{isOpen}"
             class="nav-link dropdown-toggle"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="nc-icon nc-layout-11" title="Hide/Show Tiles"></i>
          </a>
          <h6 class="dropdown-header text-center">Hide/Show Tiles</h6>
          <div v-for="tile in draggableTiles" v-bind:key="tile.name">
            <div class="dropdown-item">
              <input class="tileControlCheckBox" type='checkbox' @change="saveTileHiddenState(tile)" :checked="!tile.hidden"/>
              {{tile.name}}
            </div>
          </div>
          <p-button @click="resetTilesToInitialLayout" class='resetTileButton'>Reset</p-button>
        </drop-down>

        <drop-down icon="nc-icon nc-settings-gear-65" position="right" direction="none" class="nav-item btn-rotate dropdown">
          
          <h6 class="dropdown-header">Settings</h6>
          <a class="dropdown-item" @click="goToMyAccount">My Account</a>
          <a class="dropdown-item" @click="callLogout">Logout</a>
        </drop-down>
      </ul>

      <el-dialog
        :visible.sync="modalControls.messageModal"
        :center='true'
        :append-to-body="true"
        width="75%">
        <MessageForm :key="componentKeyThree" @sendMessage="sendMessage" :sendUserSurvey="this.getUserSurvey()" :messageSubject="this.getMessageSubject()" :messageContent="this.messageContent" :to='[selectedUsersLogin]'></MessageForm>
      </el-dialog>
      <el-dialog
        :visible.sync="modalControls.documentModal"
        :center='true'
        :append-to-body="true"
         width="45%">
         <AssignDocument></AssignDocument>
      </el-dialog>

    </template>
  </navbar>
</template>
<script>
  import { Navbar, NavbarToggleButton, Modal } from 'src/components/UIComponents';
  import PracticeServices from "src/services/practices/practiceServices.js"	
  import MessagingServices from "src/services/Messaging/MessagingServices.js"
  import MessageForm from "@/components/UIComponents/MessageForm.vue"
  import AssignDocument from "@/components/Dashboard/Views/Resource/AssignDocument.vue"
  import {redirectToOldPracticeDashboard} from "@/util/OldDashboardLink.js";
  import {logout} from "@/util/LogoutProcess"
  

  export default {
    components: {
      Navbar,
      NavbarToggleButton,
      Modal,
      MessageForm,
      AssignDocument,
    },
    data() {
      return {
        activeNotifications: false,
        showNavbar: false,
        modalControls: {
          messageModal: false,
          documentModal:false
        },
        componentsList: "",
        hasValhallaScale: "",
        componentKey: 0,
        componentKeyTwo: 1,
        componentKeyThree: 2,
        componentKeyFour: 3,
        surveys: [],
        practiceData: [],
        practiceHasSurveys: "",
        sendUserSurvey: "",
        messageSubject: "",
        messageContent: "",
      }
    },
    computed: {
      isOnDraggableDashboard() {
        if(this.$route.meta.draggableGridStoreModule) {
          return true
        }
        return false
      },
      draggableTiles() {
          return this.$store.getters[`${this.$route.meta.draggableGridStoreModule}/getLayout`]
      },
      PinnedUserAndNotLocalHost() {
        if(location.host.toLowerCase().indexOf('localhost') >= 0) {
          return false;
        } else if(this.$route.matched[0].path == '/selecteduser') {
          this.getSurveysByPractice();
          this.loadUserComponents();
          return true;
        } else {
          return false;
        }
      },
      getUserFreepass() {
        var fp = "Y";
        var zfp_sc = ".@!#$%&'*+-/=?^_`{|}~.1234567890";
        var zfp_sc2 = "qwertyuiopasdfghjklzxv0987654321";
        var ztxt2 = "";
        var ztxt = this.$store.getters["pinnedUser/getPinnedUsersLogin"];
        var zc;
        var zcc;

        for (var zct = 0; zct < ztxt.length; zct++)
        {
            zc = ztxt.substr(zct,1);
            if (zfp_sc.indexOf(zc) > -1)
            {
                zc = zfp_sc2.substr(zfp_sc.indexOf(zc), 1);
            }
            else
            {
                zcc = zc.charCodeAt(0) + 5;
                if (zcc > 90)
                {
                    zcc -= 26;
                }
                zc = String.fromCharCode(zcc) + "";
            }

            ztxt2 = zc + ztxt2;
        }

        fp += ztxt2;
        return fp;
      },
      selectedUsersLogin() {
        if(this.$store.getters['pinnedUser/isUserPinned']) {
          return this.$store.getters["pinnedUser/getPinnedUsersLogin"]
        } else {
          return "No User Pinned"
        }
      },
      // showAIChatBotIcon() {
      //       var role = this.$store.getters["currentUser/getCurrentUsersRole"]
      //       if (role == 'MANAGEMENT' || role == 'PRACTICE-MANAGEMENT' || role == 'SERVICE' || role == 'PROVIDER' || role == 'COACH') {
      //         console.log("role of user", role);
      //         return true
      //       } else {
      //           return false
      //       }
      // }
    },
    methods: {
      getUserSurvey() {
        return this.sendUserSurvey;
      },
      getMessageSubject() {
        return this.messageSubject;
      },
      getMessageContent() {
        return this.messageContent;
      },
      async getPracticeInfo() {
          var retrievedPracticeRecord = await PracticeServices.getCurrentPractice(this.$store.getters["currentUser/getCurrentUsersPractice"])
          if(retrievedPracticeRecord && retrievedPracticeRecord.result){
          this.practiceData = retrievedPracticeRecord.result
          }
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
      },
      saveTileHiddenState(tile) {
        tile.hidden = !tile.hidden
        this.$store.commit(`${this.$route.meta.draggableGridStoreModule}/saveTileHiddenState`, tile)
      },
      resetTilesToInitialLayout() {
        this.$store.dispatch(`${this.$route.meta.draggableGridStoreModule}/resetLayoutToInitialState`)
      },
      openUserMessageModal() {
        this.sendUserSurvey = "";
        this.messageSubject = "";
        this.messageContent = "";
        this.reloadMessagePanel();
        this.modalControls.messageModal = true;
      },
     async openUserDocumentModal(){
         this.sendUserSurvey = "";
        this.messageSubject = "";
        this.messageContent = "";
        this.modalControls.documentModal = true;
        this.$store.dispatch('patientInteractionTimer/recordAction', 'documentAssigned')
      },
      sendSurvey(survey) {
        var surveyMessage = "";
        var surveyUrl = "";
        this.sendUserSurvey = survey.name;

        if(this.practiceData.short_name != '') {
          this.messageSubject = this.practiceData.short_name + " would like you to complete this Survey";
          surveyUrl += "https://" + this.practiceData.code.toLowerCase() + "/portal/main/formdriver.ASP?formn=" + survey.name + "&fp=" + this.getUserFreepass;

          surveyMessage += "Hi " + this.$store.getters["pinnedUser/getPinnedUsersFirstName"] + ", <br><br>" + this.practiceData.short_name + " would like you to complete this Survey:<br><br>";
          surveyMessage += "<a href='" + surveyUrl + "'>" + survey.title + "</a><br><br>";
          surveyMessage += "Be well!<br>";
          surveyMessage += this.practiceData.short_name + "<br><br>";
          surveyMessage += "You are receiving this message from " + this.practiceData.short_name + ".<br><br>" 
          surveyMessage += "If you have received this message in error please contact <a href='mailto:" + this.practiceData.email + "'>" + this.practiceData.email + "</a> or call " + this.practiceData.phone + ".";

          this.messageContent = surveyMessage;
        } else {
          this.messageSubject = "Please complete this Survey";
          this.messageContent = survey.title;
        }

        this.reloadMessagePanel();
        this.modalControls.messageModal = true;
        this.$store.dispatch('patientInteractionTimer/recordAction', 'surveySent')
      },
      sendMessage(message){
        this.modalControls.messageModal = false
        var logins = this.$store.getters["pinnedUser/getPinnedUsersLogin"];
         var practice = this.$store.getters["currentUser/getCurrentUsersPractice" ];
         var currentUser= this.$store.getters["currentUser/getCurrentUsersLogin"];
         var sendEmailMessage={
           Login:logins,
           CurrentUser:currentUser,
           PracticeCode:practice,
           messageFrom:message.from,
           messageReplyTo:message.replyTo,
           messageSubject:message.subject,
           messageDeliveryType:message.deliveryType,
           messageBody:message.content,
           document:message.fileData,
           app:'true'
         }
        MessagingServices.sendMessageToListOfUsers(sendEmailMessage)
        // Notify of success
          this.$notify({
            title: 'Message Sent',
            horizontalAlign: 'left',
            verticalAlign: 'bottom',
            type: 'success',
            timeout: 3000,
            showClose: false
        })
        this.$store.dispatch('patientInteractionTimer/recordAction', 'messageSent')
      },
      openInitialReport() {
        var login = this.$store.getters["pinnedUser/getPinnedUsersLogin"];

        if(login != '') {
          var url = "../home/applets/scale_data_report_1.asp?print=0&zthis_login=" + login;
          this.$store.dispatch('patientInteractionTimer/recordAction', 'openedInitialReport')
          window.open(url);
        }
      },
      openFollowUpReport() {
        var login = this.$store.getters["pinnedUser/getPinnedUsersLogin"];

        if(login != '') {
          var url = "../home/applets/scale_data_report_2.asp?print=0&zthis_login=" + login;
          this.$store.dispatch('patientInteractionTimer/recordAction', 'openedFollowUpReport')
          window.open(url);
        }
      },
      async loadUserComponents() {
        var thisPractice = this.$store.getters["currentUser/getCurrentUsersPractice"];
        var thisUser = this.$store.getters["pinnedUser/getPinnedUsersLogin"];

        var components = await PracticeServices.LoadComponentsList(thisPractice, thisUser);
        if(components && components.result)
        {
          this.componentsList = components.result;
          
          if(this.componentsList?.indexOf(",VALHALLA_SCALE,") > -1) {
            this.hasValhallaScale = "1";
          };

          this.reloadComponents();
        }
      },
      async getSurveysByPractice() {

        var thisPractice = this.$store.getters["currentUser/getCurrentUsersPractice"];
        var surveys = await PracticeServices.getSurveysByPractice(thisPractice);
        if(surveys)
        {
            this.surveys = surveys.result;

            if(this.surveys.length > 0) {
            this.practiceHasSurveys = "1";
           }

        this.reloadSurveyData();
        }
       
      },
      reloadComponents() {
        this.componentKey += 1;
        this.componentKeyTwo += 1;
      },
      reloadMessagePanel() {
        this.componentKeyThree += 1;
      },
      reloadSurveyData() {
        this.componentKeyFour += 1;
      },
      goToMyAccount() {
        redirectToOldPracticeDashboard("../home/healthtrac/my_account.asp", null, {SPH_RETURN: ""})
      },
      callLogout() {
        logout()
      }
    },
    mounted() {
      this.getPracticeInfo();
    }
  }
</script>

<style scoped>
.modal-primary {text-align: center;}

.resetTileButton {
  margin-left: 30%;
}
</style>

<style>
.send-user-message-modal .modal-dialog {min-width:830px;}
.coust-mt-2{
  margin-top: 0.9rem !important;
}
</style>